import { NeoModel, ValueObject } from "@singularsystems/neo-core";
import FileGroupingFileSpecImportProcedureLookup from "../Lookups/FileGroupingFileSpecImportProcedureLookup";

@NeoModel
export default class SaveFileGroupingImportProcedureCommand extends ValueObject {
    public fileGroupingFileSpecImportProcedure = new FileGroupingFileSpecImportProcedureLookup();
}